import * as React from "react"

const Ticket = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M2 3.5h12v1.67a3.001 3.001 0 0 0 0 5.66v1.67H2v-1.67a3.001 3.001 0 0 0 0-5.66V3.5ZM13 8a2 2 0 0 1 2-2V2.5H1V6a2 2 0 1 1 0 4v3.5h14V10a2 2 0 0 1-2-2Zm-3 .5h.5v-1h-5v1H10Z" />
  </svg>
)

export default Ticket
